import React, { useEffect, useState } from "react";
import { WeeklyNote } from "../pages/UncompletedChecklists";
import { Unit } from "./UnitCard";
import { Button } from "flowbite-react";
import Swal from "sweetalert2";
import { useTranslation } from "react-i18next";
import axios from "axios";
import { Moment } from "moment";

interface UncompletedChecklistCardProps {
    unit: Unit;
    weeklyNote?: WeeklyNote,
    weekDate: Moment|null,
    onNoteSaved?: () => void;
}
const UncompletedChecklistCard: React.FC<UncompletedChecklistCardProps> = ({ unit, weeklyNote, weekDate, onNoteSaved }) => {

    const [t] = useTranslation('common');

    // Accept onNoteSaved as a prop
    const openNote = (weeklyNote?: WeeklyNote) => {
        Swal.fire({
            title: 'Edit weekly note for ' + unit.name,
            input: 'textarea',
            inputValue: weeklyNote?.note,
            showCancelButton: true,
            confirmButtonText: t('Save'),
            customClass: {
                confirmButton: '!bg-sagreen',
                cancelButton: '!bg-sared',
            }
        }).then((result) => {
            if(result.isConfirmed){
                axios.post(`/checklists/weekly_note`, {
                    date: weekDate,
                    note: result.value,
                    unit: '/api/units/' + unit.id
                }).then(() => {
                    if (typeof onNoteSaved === 'function') {
                        onNoteSaved();
                    }
                });
            }
        })
    }

    return (
        <div className="unit-card bg-[#F5F5F5]  px-2 py-2 rounded-lg mt-2">
            <div className="flex items-center justify-between">
                <div>
                    <div className="unit-card-head text-[13px] font-semibold text-sablack">
                        {unit.name}
                    </div>
                    <div className="unit-card-text unit-card-head text-[13px] font-normal text-sablack">
                        {unit.address}
                    </div>
                </div>
                <Button className={"" + (weeklyNote && weeklyNote.note ? 'bg-green-400': 'bg-blue-400')} size={'xs'} pill onClick={() => openNote(weeklyNote)}>
                    <i className="ri-sticky-note-line"></i>
                </Button>
            </div>
        </div>
    );
}



export default UncompletedChecklistCard;